import React, {Component} from 'react';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import {withSnackbar} from 'notistack';
import { debounce } from "lodash";
import * as _ from 'lodash'
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import {Typography} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import MomentClipInput from "./MomentClipInput";
import {getClipMoments} from "../actions/momentClipsActions";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import MomentService from '../Services/MomentsService'
import showSnackBar from '../Utilities/SnackbarHelper';
import ContentSearch from "../ContentSearch";
import TextField from "@material-ui/core/TextField";
import {ERROR, SUCCESS, WARNING} from "../constants";
import PlaylistList from "./PlaylistList";
import ClipList from "./ClipList";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {capitalizeFirstLetter} from "../Utilities/StringUtils";
import EmojiEventIcon from "@material-ui/icons/EmojiEvents"
import WarningIcon from "@material-ui/icons/Warning"

import Competition from "./Competition";
import ReactGA from 'react-ga';
import {
    MOMENTS_CLIPS, FILTER_BY_TITLE, FILTER_BY_TAG, EDIT_MOMENT_CLIP, SAVE_MOMENT_CLIP,
    ADD_NEW_MOMENT_CLIP, DELETE_MOMENT_CLIP, NEW_CLIP_MOMENT, SEARCH_WITH_CLIP_TITLE,
    SEARCH_WITH_CLIP_CID,
    MOMENT_CHAMPIONSHIP
} from '../Utilities/GAUtils'
import RMMService from "../Services/RMMService";

const styles = theme => ({
    container: {
        position: 'relative',
        minHeight: "100vh",
        overFlowY: "scroll"
    },
    searchBar: {
        flex: 1
    },
    addMoreButton: {
        align: "right"
    },
    cidInput: {
        marginTop: "-13px"
    },
    formTitle: {
        fontSize: "20px"
    },
    momentClipsContainer: {},
    clipMomentsForm: {
        minHeight: "70vh",
    },
    adjustMarginEdit: {
        marginTop: "-25px"
    },
    adjustMarginCreate: {
        marginTop: "-25px"
    },
    warningIcon: {
        marginTop: "-4px",
    }
});


class Clip extends Component {

    constructor(props) {
        super(props);

        this.state = {
            allMomentClips: null,
            momentClips: [],
            suggestions: [],
            cid: '',
            searchTitle: '',
            searchTags: '',
            inputSearchText: '',
            authenticationDone: false,
            showDRMError: false
        };

        this.handleSuggestionSelect = this.handleSuggestionSelect.bind(this);
        this.loadAllMomentClipsBySearch = this.loadAllMomentClipsBySearch.bind(this);
        this.loadAllMomentClipsBySearch = debounce(this.loadAllMomentClipsBySearch, 500);
    }

    componentDidMount() {
        this.loadAllMomentClips();
    }

    loadAllMomentClips() {
        let self = this;
        MomentService.getAllMomentClips().then((response) => {
            if (response && response.data && response.data.entity && response.data.entity.length > 0) {
                self.setState({allMomentClips: response.data.entity});
            } else {
                if (response && response.data && (response.data.responseType === "SUCCESS")) {
                    self.setState({allMomentClips: response.data.entity});
                }
            }
        });
    }

    loadAllMomentClipsBySearch() {
        let self = this;
        MomentService.searchMomentClips(self.state.searchTitle,self.state.searchTags).then((response) => {
            if (response && response.data && response.data.entity && response.data.entity.length > 0) {
                self.setState({allMomentClips: response.data.entity});
            } else {
                if (response && response.data && (response.data.responseType === "SUCCESS")) {
                    self.setState({allMomentClips: response.data.entity});
                }
            }
        });
    }

    loadMomentClipsByCID(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.setState({inputSearchText: "toClearInputSearchText"});
            this.loadMomentClips(this.state.cid);
        }
    }

    loadMomentClips(cid) {
        this.getClipMoments(cid);
    }


    getClipMoments(cid) {

        let self = this;

        self.setState({momentClips: []});

        RMMService.getRMMProfile(cid).then((response) => {
            if (response && response.data) {
                let rmmResponseData = response.data;
                if (rmmResponseData.status === "SUCCESS") {
                    if (rmmResponseData.entity && rmmResponseData.entity.length > 0 && rmmResponseData.entity[0].rmmProfile) {
                        let rmmProfile = rmmResponseData.entity[0].rmmProfile;

                        let drm = rmmProfile.drm;

                        console.log({drm});

                        self.setState({drm: drm})
                        if (drm === "Standard") {
                            self.setState({showDRMError: true})
                        } else {
                            self.setState({showDRMError: false})
                        }

                    }
                } else {
                    showSnackBar("Could not get DRM type.", WARNING, self);
                }
            } else {
                showSnackBar("Could not get DRM type.", WARNING, self);
            }
        }).catch((errors) => {
            showSnackBar("Could not get DRM type.", WARNING, self);
        })

        MomentService.getMomentClipsForCID(cid).then((response) => {
            if (response && response.data && response.data.entity && response.data.entity.length > 0) {
                let momentClips = response.data.entity;
                self.setState((state, props) => {
                    return {momentClips: momentClips};
                });
            } else {
                let momentClips = [];
                momentClips.push({});
                self.setState({momentClips: momentClips});
            }
        }).catch((errors) => {

        });


    }

    componentWillUnmount() {

    }

    handleChangeSearch = element => event => {
        let self = this;
        this.setState({
            [element]: event.target.value,
        },()=>{
            self.loadAllMomentClipsBySearch();
        });
        let eventAction = element === 'searchTitle' ? FILTER_BY_TITLE : FILTER_BY_TAG;
        ReactGA.ga('send', 'event',
                MOMENTS_CLIPS,
                eventAction,
                event.target.value,
                1);
    };

    handleChange = element => event => {
        let self = this;
        this.setState({
            [element]: event.target.value,
        });
    };

    handleSearchByCIDGoogleAnalytics = (event) => {
        ReactGA.ga('send','event',
                MOMENTS_CLIPS,
                SEARCH_WITH_CLIP_CID,
                event.target.value,
                1)
    }

    addMoreClipMoments() {
        let momentClips = this.state.momentClips;
        momentClips.push({});
        this.setState(momentClips);
        ReactGA.ga('send','event',
                MOMENTS_CLIPS,
                ADD_NEW_MOMENT_CLIP,
                this.state.cid,
                1)
    }

    handleSuggestionSelect(event) {
        let self = this;
        this.setState({cid: event}, () => {
            self.getClipMoments(event);
        }, function () {

        })
        ReactGA.ga('send','event',
                MOMENTS_CLIPS,
                SEARCH_WITH_CLIP_TITLE,
                event,
                1)
    }

    handleClipMomentSave(event) {
        let momentClip = event;
        momentClip.cid = this.state.cid;

        let self = this;

        MomentService.saveMomentClips(self.state.cid, momentClip).then((response) => {

            // self.setState({momentClips:[]});

            if (response.data.responseType === "SUCCESS") {
                showSnackBar("Clip moment saved successfully!", SUCCESS, self);
                this.loadMomentClips(self.state.cid);
            } else {
                let errorMessages = "";
                if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                    errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                }
                showSnackBar(`Clip moment can not be saved. ${errorMessages}`, ERROR, self);
            }
        });
        ReactGA.ga('send','event',
                MOMENTS_CLIPS,
                SAVE_MOMENT_CLIP,
                this.state.cid,
                1)
    }

    handleClipMomentDelete(event, index) {

        console.log("in delete button");

        let momentClip = event;
        let self = this;
        let momentClipCID;
        console.log(event);
        _.forEach(this.state.allMomentClips, function(momentClip) {
            if(momentClip.id=== event) {
                momentClipCID = momentClip.cid;
            }
        })
        if (momentClip && momentClip.id) {
            MomentService.deleteMomentClip(momentClip.id).then((response) => {

                if (response.data && response.data.responseType === "SUCCESS") {

                    self.state.momentClips.splice(index, 1);

                    self.setState({momentClips: self.state.momentClips}, () => {
                        if ((!self.state.momentClips) || (self.state.momentClips.length === 0)) {
                            self.setState({momentClips: [{}]});
                        }
                    });

                    showSnackBar("Clip moment deleted successfully!", SUCCESS, self);
                } else {
                    let errorMessages = "";
                    if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                        errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                    }
                    showSnackBar(`Failed to delete clip moment. ${errorMessages}`, ERROR, self);
                }

            });
        } else {
            this.state.momentClips.splice(index, 1);
            self.setState({momentClips: this.state.momentClips});
            // this.loadMomentClips();
        }
        ReactGA.ga('send','event',
                MOMENTS_CLIPS,
                DELETE_MOMENT_CLIP,
                momentClipCID,
                1)

    }

    handleCreate(event) {
        let self = this;
        let mode = "create";
        this.setState({

                mode: mode,
                id: '',
                title: '',
                thumbnails: [],
                momentClips: [],
                tags: '',
                cid: '',
                momentClipId: ''
            },
            () => {

            });
        ReactGA.ga('send', 'event',
                MOMENTS_CLIPS,
                NEW_CLIP_MOMENT,
                '',
                1)
    }

    handleEditFromList(id,cid) {
        console.log(cid);
        let mode = "edit";
        this.setState(
            {
                mode: mode, title: '',
                thumbnails: [],
                momentClips: [],
                tags: '',
                cid:cid,
                momentClipId: ''
            }
        );
        this.loadMomentClips(cid);
        ReactGA.ga('send','event',
                MOMENTS_CLIPS,
                EDIT_MOMENT_CLIP,
                cid,
                1)
    }

    closeForm() {
        this.setState({
            mode: 'list',
            title: '',
            thumbnails: [],
            momentClips: [],
            tags: '',
            momentClipId: ''
        });
    }

    openCompetition() {
        this.setState({
            mode: 'competition',
            title: '',
            thumbnails: [],
            momentClips: [],
            tags: '',
            momentClipId: ''
        });
        ReactGA.ga('send','event',
                MOMENTS_CLIPS,
                MOMENT_CHAMPIONSHIP,
                '',
                1)
    }

    closeCompetition() {
        this.setState({
            mode: 'list',
            title: '',
            thumbnails: [],
            momentClips: [],
            tags: '',
            momentClipId: ''
        });
    }

    render() {

        const {classes, theme} = this.props;

        let formTitle = `${this.state.mode} Clip Moments`;
        if (this.state.mode === "edit") {
            formTitle = `${formTitle} for CID ${this.state.cid}`
        }
        formTitle = capitalizeFirstLetter(formTitle);

        return <React.Fragment>
            <div className={classes.container}>
                {((this.state.mode === "create") || (this.state.mode === "edit")) &&
                    <>
                <Card className={classes.clipMomentsForm}>
                    <CardHeader classes={{title:classes.formTitle}} title={formTitle}
                                action={
                                    <IconButton aria-label="delete" onClick={this.closeForm.bind(this)}>
                                        <CloseIcon fontSize="small"/>
                                    </IconButton>
                                }/>
                    <CardContent>

                        {(this.state.mode === "create") &&
                            <>
                            <Grid container direction="row"
                                  justify="center"
                                  alignItems="center" spacing={0}>

                                <Grid item xs={6}>
                                    <Grid container>
                                        <Grid item xs={8}>
                                            <ContentSearch inputText={this.state.inputSearchText}
                                                           handleSuggestionSelect={this.handleSuggestionSelect.bind(this)}/>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Typography variant={"body2"}>
                                                OR
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextField
                                                id="cid" onKeyDown={this.loadMomentClipsByCID.bind(this)}
                                                className={classes.cidInput}
                                                label="Enter a CID"
                                                value={this.state.cid}
                                                onChange={this.handleChange('cid')}
                                                placeholder={"CID e.g. 1128357174"}
                                                margin="normal"
                                                onBlur={this.handleSearchByCIDGoogleAnalytics}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>


                                <br/>
                        </>}


                        <Grid container
                              className={this.state.mode === "edit" ? classes.adjustMarginEdit : classes.adjustMarginCreate}
                              justify="flex-start">
                            <Grid item xs={10}></Grid>
                            {this.state.momentClips && this.state.momentClips.length > 0 &&
                            <Button xs={2} variant="contained" color="default"
                                    onClick={this.addMoreClipMoments.bind(this)}
                                    className={classes.addMoreButton}>
                                <AddIcon/> Add More
                            </Button>}
                        </Grid>

                        <Grid container direction="row"
                              justify="center"
                              alignItems="center" spacing={0}>
                            <Grid item xs={12}>
                                {this.state.showDRMError === true &&
                                <>
                                    <Typography variant={"h6"} color={"secondary"} align={"center"}>
                                        Please do not create moments for CIDs with Standard DRM.
                                    </Typography>
                                </>
                                }
                            </Grid>
                        </Grid>

                        <Grid container direction="row"
                              justify="center"
                              alignItems="center" spacing={0}>

                            <Grid item xs={12}>
                                {this.state.momentClips && this.state.momentClips.length > 0 &&
                                <React.Fragment>
                                    {this.state.momentClips.map((momentClip, index) => {
                                        return (
                                            <React.Fragment key={index}>

                                                <MomentClipInput moment={momentClip} key={momentClip.id} index={index}
                                                                 handleSave={this.handleClipMomentSave.bind(this)}
                                                                 handleDelete={this.handleClipMomentDelete.bind(this)}
                                                />
                                                <Divider/>
                                            </React.Fragment>
                                        )
                                    })}
                                    <Typography variant={"caption"}>
                                        The "seconds" in the start and end time must be multiple of 6 or 0, e.g.
                                        05:01:36
                                    </Typography>

                                    {this.state.drm && this.state.drm !== null &&
                                    <>
                                        <br/>
                                        <Typography variant={"caption"}>
                                            DRM : {this.state.drm}
                                        </Typography>
                                    </>
                                    }


                                </React.Fragment>
                                }

                            </Grid>
                        </Grid>


                    </CardContent>
                </Card>
                        <br/>
                        <Divider/>
                    </>
                }


                {((this.state.mode === "competition")) &&
                    <Competition mode={"momentClips"} closeCompetition={this.closeCompetition.bind(this)}/>
                }

                <Card>
                    <CardContent>


                        <Grid container alignItems="center" spacing={2} >
                            <Grid item xs={3}>
                                <Typography variant={"h6"}>
                                    Clip Moments Library
                                </Typography>
                            </Grid>


                            <Grid item xs={3}>
                                <TextField
                                    fullWidth={true}
                                    id="searchTags"
                                    className={classes.cidInput}
                                    label="Filter by Title"
                                    value={this.state.searchTitle}
                                    onChange={this.handleChangeSearch('searchTitle')}
                                    placeholder={"Title e.g. Sunshine"}
                                    margin="normal"
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    fullWidth={true}
                                    id="searchTags"
                                    className={classes.cidInput}
                                    label="Filter by tags"
                                    value={this.state.searchTags}
                                    onChange={this.handleChangeSearch('searchTags')}
                                    placeholder={"Tags e.g. Comedy"}
                                    margin="normal"
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <Button aria-label="Create" variant="contained" color='primary' onClick={this.handleCreate.bind(this)}
                                        className={classes.button}>
                                    New Clip Moment
                                </Button>

                            </Grid>
                            <Grid item xs={1}>

                                {/*<IconButton aria-label="rewards">*/}
                                {/*    <EmojiEventIcon fontSize={"large"} onClick={this.openCompetition.bind(this)} color={"primary"}/>*/}
                                {/*</IconButton>*/}
                            </Grid>
                        </Grid>
                        <br/>
                        <ClipList momentClips={this.state.allMomentClips}
                                  handleEdit={this.handleEditFromList.bind(this)}
                                  handleCreate={this.handleCreate.bind(this)}/>
                    </CardContent>
                </Card>




            </div>

        </React.Fragment>
    }
}


Clip.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        momentClips: state.momentClip.momentClips
    }
};

const mapDispatchToProps = (dispatch) => {
    return {getClipMoments: (cid) => dispatch(getClipMoments(cid))}
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, {withTheme: true})(withSnackbar(Clip)));
